import { useTranslation } from "react-i18next";
import { _adr } from "../../../../address";
import { useDealer } from "../../../../tools/api";
import { complexDigitToman, convertToJalaliWithTime } from "../../../../tools/tools";
import PendingDocsPage from "../../../auxiliary/pending/PendingDocsPage";
import "../../shop/sp.scss";

const SPListPendingDocument = () => {
	const [t] = useTranslation("global");
	const { querySPPurchaseDealerByState } = useDealer();
	return (
		<PendingDocsPage
			title={t("simcardpurchase.pending.list.title")}
			prefix="sp"
			query={querySPPurchaseDealerByState}
			stateFilter={{ purchasestate: [1, 15] }}
			commissionTitle="سود شما از فروش"
			uploadPath={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Pending.Index + _adr.SimCardPurchase.Pending.upload}
			toRow={(item) => ({
				trackcode: item.stR_PurchaseFollowupCode,
				msisdn: item.inT_MSISDN,
				type: item.stR_BundleName,
				price: complexDigitToman(item.inT_PurchaseAmount),
				commission: complexDigitToman(item.inT_PackageSalesCommission),
				purchaseDate: convertToJalaliWithTime(item.dtE_PurchaseDate),
			})}
		/>
	);
};

export default SPListPendingDocument;
